import { FC } from "react";

import { InteractionMode } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import {
  pageSelectors,
  selectIsCurrentSectionUserAssignedToPageGroupByPageId,
} from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

interface GroupNotAssignedBannerProps {
  pageId: string;
}

export const GroupNotAssignedBanner: FC<GroupNotAssignedBannerProps> = ({ pageId }) => {
  const { canParticipateInSection } = useCapabilities();
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["interaction_mode"]);
  const isAssignedToPageGroup = useAppSelector((s) =>
    selectIsCurrentSectionUserAssignedToPageGroupByPageId(s, pageId),
  );

  const showCurrentStudentNotInGroupBanner =
    canParticipateInSection &&
    (page?.interaction_mode === InteractionMode.ASSIGN_STUDENTS ||
      page?.interaction_mode === InteractionMode.COPY_GROUPS) &&
    !isAssignedToPageGroup;

  if (!showCurrentStudentNotInGroupBanner) {
    return null;
  }

  return (
    <Banner className="group-card" kind="warning">
      {t("group_configuration_card.group_not_assigned")}
    </Banner>
  );
};
